module.exports = __webpack_public_path__ + "img/area_10.b9a2a733.png";